<template>
  <section class="page-tuition">
    <div class="banner-tuition py-5">
      <app-loading :isFull="false" v-if="isLoading"/>

      <div class="container">
        <div class="row">
          <div class="col-12">
            <header class="text-right">
              <h1 class="mb-0 font-20">تدریس در مادیا</h1>
              <p
                class="text-right font-18 py-4"
              >"دانش تان را به اشتراک بگذارید، دیده شوید و از تخصص تان کسب درآمد کنید"</p>
            </header>
            <div class="form-action d-flex justify-content-center align-items-center">
              <router-link
                v-if="isLogin && !Instructor"
                to="/v1/instructor-request"
                class="d-block  bttn-fill bttn bttn-success "
                v-ripple
                :title="$t('button.getStartedTuition')"
              >
                <span class="font-16">{{ $t('button.getStartedTuition') }}</span>
              </router-link>
              <button
                v-if="!isLogin"
                @click="showModalLogin"
                class="d-block  bttn-fill bttn bttn-success "
                v-ripple
                :title="$t('button.getStartedTuition')"
              >
                <span class="font-16">{{ $t('button.getStartedTuition') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="whay-madya">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <header class="py-5 text-center">
              <h2 class="font-20 pb-2 px-3 d-inline-block">مادیا چگونه کار می کند؟</h2>
            </header>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="box panel-card d-flex flex-column text-center py-3">
              <i class="flaticon-objective icon-35 py-1"></i>
              <h3 class="font-18 py-2">هدف</h3>
              <p
                class="py-2 font-14"
              >از یک متخصص به یک مدرس تبدیل شوید، در دانش و تخصصی که دارید شناخته شوید. شما می‌توانید هرچیزی را که دوست دارید، آموزش دهید.</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="box panel-card d-flex flex-column text-center py-3">
              <i class="flaticon-video-camera icon-35 mdi py-1"></i>
              <h3 class="font-18 py-2">ایجاد</h3>
              <p
                class="py-2 font-14"
              >به آسانی با استفاده از ابزار های طراحی رایگان، دروه آنلاین خود را ایجاد نمایید.</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="box panel-card d-flex flex-column text-center py-3">
              <i class="flaticon-tutorial icon-35 py-1"></i>
              <h3 class="font-18 py-2">آموزش</h3>
              <p
                class="py-2 font-14"
              >به میلیون ها مخاطب در بزرگترین بازار آموزش کشور دسترسی داشته باشید و دوره خود را بر روی هر دستگاه، در هر زمان ارائه نمایید.</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="box panel-card d-flex flex-column text-center py-3">
              <i class="flaticon-money icon-35 mdi py-1"></i>
              <h3 class="font-18 py-2">درآمد</h3>
              <p
                class="py-2 font-14"
              >بطور جدی کسب درآمد کنید، برند شخصی خودتان را بسازید و یک تغییر واقعی در زندگی مخاطبین ایجاد نمایید.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <helpmadya />
  </section>
</template>

<script>
import toggleOpen from "cp/min-component/open-colose.vue";
import  helpmadya from 'cp/min-component/helpmadya.vue'

export default {
  name: "page-tuition",
  components: {
    toggleOpen,
    helpmadya
  },
  data() {
    return {
      Instructor: false,
      isLoading: true
    };
  },
  mounted() {
    this.instructorCheck();
  },
  methods: {
    async instructorCheck() {
      const res = await this.checkInstructor();
      if (res) {
        this.Instructor = res;
      }
      this.isLoading = false;
    }
  }
};
</script>

<style lang="less">
@import (reference) "../assets/css/variable.less";
@-webkit-keyframes bgMove {
  0% {
    background-position: 0 0;
  }
  to {
    background-position: -400px 0;
  }
}

@keyframes bgMove {
  0% {
    background-position: 0 0;
  }
  to {
    background-position: -400px 0;
  }
}
.page-tuition {
  .box-clear;
  header {
    h1 {
      color: @withe;
    }
    p {
      color: @withe;
    }
  }
  .banner-tuition {
    height: 250px;
    background: url("../assets/img/goran-ivos-343495-unsplash.jpg") top;
    background-attachment: fixed;
    position: relative;
    animation: bgMove 20s linear infinite;
    background-attachment: fixed;
    background-size: 80%;
    z-index: 0;
    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.534);
    }
  }

  .whay-madya {
    h2 {
      color: @primaryTextColor;
      .line;
    }
    .box {
      min-height: 230px;
      background-color: #f3f3f3;
      p {
        height: 80px;
      }
      i {
        height: 60px;
        color: #5d5c5c;
      }
    }
  }

  .tabs-about-madya {
    .nav-pills .nav-link.active,
    .nav-pills .show > .nav-link {
      background-color: @green !important;
    }
    .nav {
      justify-content: center;
    }
    .lis-tabs-standard {
      li {
        b {
          cursor: pointer;
        }
        border-bottom: 1px solid #e3e3e3;
        padding: 10px 0;
        .font-16.my-2 {
          border-bottom: 1px solid rgba(224, 224, 224, 0.37);
          padding: 0 10px;
          &:last-child {
            border: none;
          }
        }
      }
    }
    .nav-tabs .nav-link {
      color: @primaryTextColor;
    }
    .nav-tabs .nav-item.show .nav-link,
    .nav-tabs .nav-link.active {
      color: @secondaryTextColor;
    }
  }
}
@media screen and (max-width: 768px) {
  .tabs-about-madya {
    .table.font-16 {
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 593px) {
  .tabs-about-madya {
    .table.font-16 {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/tuition.vue